export const environment = {
PRODUCTION: false,
NAV_TYPE: 'dev',
CREW_APP_BACKEND_API_BASE_URL: 'https://api.stoltdev.com/st-css20-member-integration/v1',
CREW_APP_ENCRYPTION_KEY: 'LZnsEJqjGckVsc9Dcej60lcFdAeAp+zuLc4YzHZbx88=',
CREW_APP_ENCRYPTION_IV: 'yr7imEl0vlgk07U2xEXtbw==',
CSS_SENTRY_DSN: 'https://244f8b573b4e18aa7638e27ce3331218@o4509530252574720.ingest.de.sentry.io/4509543512277072',
POSTHOG_API_KEY:'phc_XQEdP55O6sv8AFgS8aTBPTdLpMYL1wjyrCOQUuanMIv',
POSTHOG_API_HOST:'https://eu.i.posthog.com',
POSTHOG_API_DEFAULTS: '2025-07-07',
POSTHOG_ENABLED_TRACKING:false,
DEFAULT_BANK_ACCOUNTS:'{5121: 543212345, 5084: 123454321}'
};
